// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3ns-i","header":"PatientBlock_header__1NTFH","label":"PatientBlock_label__33hEi","option":"PatientBlock_option__HeXmT"};